<template>
  <button
    :class="[$style.category, { 'is-active': isActive }]"
    data-test="category-item"
    @click="$emit('click')"
  >
    <div
      :class="[$style.iconHolder, `is-${category}`]"
      data-test="icon-holder"
    >
      <Component :is="icon" />
    </div>
    <span :class="$style.label">
      {{ label }}
    </span>
  </button>
</template>

<script>
export default {
  props: {
    icon: {
      type: Object, // Vue Component
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    category: {
      type: String,
      required: true,
    },
  },
};
</script>

<style module lang="scss">
  $border-radius: 15px;

  .category {
    @include flex-center();

    position: relative;
    padding: 0;
    outline: none;
    border: 0;
    color: $c-white;
    background-color: transparent;
    flex-direction: column;

    @include before() {
      @include absolute(top 0 right 0 bottom 0 left 0);

      border: 2px solid $c-navy-light;
      border-radius: $border-radius;
      transition: transform 0.2s ease, opacity 0.2s ease;
    }

    @include after() {
      @include absolute(top 0 right 0 bottom 0 left 0);

      border-radius: $border-radius;
      background-image: linear-gradient($primary-gradient-start, $primary-gradient-end);
      opacity: 0;
      transform: scale(0.8);
      transition: transform 0.35s $ease-in-out, opacity 0.3s ease;
    }

    &:global(.is-active) {
      color: $c-white;

      &::before {
        opacity: 0;
        transform: scale(0.8);
      }

      &::after {
        opacity: 1;
        transform: scale(1);
      }
    }
  }

  .label,
  .iconHolder {
    position: relative;
    z-index: $z-index-1;
  }

  .label {
    font-size: $fs-small;

    @media #{$mobile-md-v-up} {
      font-size: $fs-p;
    }
  }

  .iconHolder {
    @include sizing(32px);
    @include flex-center();

    @media #{$mobile-md-v-up} {
      @include sizing(43px);
    }

    margin-bottom: 12px;
    transition: color 0.2s ease;

    :global(svg) {
      @include sizing(100%);
    }

    &:global(.is-design) {
      color: $c-red;
    }

    &:global(.is-it) {
      color: $c-blue;
    }

    &:global(.is-people) {
      color: $c-green;
    }

    &:global(.is-travel) {
      color: $c-yellow;
    }

    .category:global(.is-active) & {
      color: $c-white;
    }
  }
</style>
